module.exports = __webpack_public_path__ + "img/avt4.e51f6a6a.5e7a039b.png";